<template>
  <div>
    <div
      v-if="loading"
      class="gift-card-checkout"
    >
      <LoadingSpinner />
    </div>

    <div
      :id="frameID"
      class="hidden"
    />
    <div :id="frameIDLoaded" />
  </div>
</template>

<script lang="ts">
import LoadingSpinner from '~/core/components/shared/LoadingSpinner.vue'

import { useLangSelector } from '~/core/composable/shared/useLangSelector'

import LoadingEventBus from '~/core/events/loading'

import { DocumentScriptLoader } from '~/core/ts/legacy/helpers/DocumentScriptLoader'
import { GiftVoucherIframePathBuilder } from '~/core/ts/legacy/helpers/GiftVoucherIframePathBuilder'

definePageMeta({
  layout: 'default-no-finder',
})

type WindowWithPlugins = Window & typeof globalThis & { UTBInsertSpaBooking?: any; jQuery: any };

export default defineNuxtComponent({
  components: {
    LoadingSpinner,
  },
  setup() {
    const frameID = 'utb-iframe-spa'
    const frameIDLoaded = 'utb-iframe-spa-loaded'

    const runtimeConfig = useRuntimeConfig()
    const iframePath = runtimeConfig.public.bookingIframePath || ''

    const loading = ref(true)

    const {
      currentLang,
    } = useLangSelector()

    const route = useRoute()

    function tryToLoadIFrame(value: number) {
      new DocumentScriptLoader(document).load({
        url: iframePath,
        onLoad: async () => {
          const windowWithPlugins = window as WindowWithPlugins
          const { base, path } = GiftVoucherIframePathBuilder.build(currentLang, value)

          new windowWithPlugins.UTBInsertSpaBooking({ base, path }).insertIFrameAndPReset(frameIDLoaded)

          LoadingEventBus.hide()

          setTimeout(() => loading.value = false, 1000)
        },
      })

      if (!(window as WindowWithPlugins).jQuery) {
        setTimeout(() => tryToLoadIFrame(value), 1000)
        LoadingEventBus.show()
      }
    }

    onMounted(() => {
      const value = Number(route.query.id)

      tryToLoadIFrame(value)
    })

    return {
      loading,

      frameID,
      frameIDLoaded,
    }
  }
})
</script>

<style lang="scss" scoped>
.gift-card-checkout {
  @apply py-12;
}
</style>
